module.exports = __webpack_public_path__ + "static/media/the-truth-is-out-there.90575a41.jpg";